// extracted by mini-css-extract-plugin
module.exports = {"resourceIcon":"ResourceIcon_resourceIcon__2T-Iv"};